import 'vite/modulepreload-polyfill'

import '@/fix_for_facebook_webview'

import jQuery from 'jquery'
window.jQuery = window.$ = jQuery

import '@/swap-on-load'
import '@/embedly'
import '@/agra'
import '@/phoenix-loader'
import '@/phoenix/vue-init'
import '@/error-logger-init'
import '@/phoenix/component-loader'
import '@/phoenix/session-locale'
import '@/local/index'
import '@/petition/index'
import '@/petition/start/index'
import '@/events/form/index'
import '@/events/rsvp/index'
import '@/events/manage/index'
import '@/discussion-forum/index'
import '@/global-i18n'
import '@/cookies_consent/index'
import '@/eu-switcher'
import '@/events/attendees'
import '@/users/sure-opt-in'
import '@/timeago-loader'
import '@/password-sign-up-field'
import '@/modals'
import '@/org/event_sequence_renewal_progress'

import 'vue-multiselect/dist/vue-multiselect.css'

import Rails from '@rails/ujs'
Rails.start()
